module.exports = __webpack_public_path__ + "static/media/nHyVHQ5MUg.6dec6b08.jpg";